var React = require('react');

function CheckGreyInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":".5","stroke":"#011949","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"},[React.createElement("path",{"d":"M20.167 10.157V11a9.166 9.166 0 11-5.436-8.378","key":0}),React.createElement("path",{"d":"M20.167 3.667L11 12.842l-2.75-2.75","key":1})]));
}

CheckGreyInline.defaultProps = {"width":"22","height":"22","fill":"none"};

module.exports = CheckGreyInline;

CheckGreyInline.default = CheckGreyInline;
